const servicesData = [
  {
    id: 1,
    title: "House Extencion",
    category: "House Extentions",
    desc: "Can’t decide whether to move or extend? From legal fees to the exorbitant stamp duty payable on London homes, the reasons to stay put and improve the house you’ve already got quickly stack up. Canny Londoners are finding the shrewd move is to put your money into extending the home you’re in. A house extension is the smart way to increase space and get the home you truly want without breaking the bank. And it increases the value of your property into the bargain…",
    img: "./images/item1.jpg",
    button: "Read More",
  },
  {
    id: 2,
    title: "Basement Conversions",
    category: "Basement Conversions",
    desc: "Can’t extend outwards or upwards? Why not downwards? If you are a space-cramped, home-owning Londoner, you will know that space is at a premium in the capital. Carving out additional square footage can bring you a valuable asset. With modern technology, waterproofing and damp-proofing your basement are no longer a problem. This means you can convert your basement for almost any purpose you can think of…",
    img: "./images/item2.jpg",
    button: "Read More",
  },
  {
    id: 3,
    title: "Design & Build",
    category: "Design & Build",
    desc: "Our streamlined design and build service revives the historic “Master Builder” approach to construction. This means you only have one contractor – us, one contract, and a fixed price agreed at the outset – so no spiralling costs! We will take care of every aspect of the design, planning permissions, build and project delivery for you. This minimises the stress and potential risks for you. It also means you get your project completed sooner because …",
    img: "./images/item3.jpg",
    button: "Read More",
  },
  {
    id: 4,
    title: "Loft Conversions",
    category: "Loft Conversions",
    desc: "Looking for a quick upgrade of your loft? Our experienced, expert team can shed light on your loft conversion project and allow you to achieve a high-end product at a competitive price. Check out our easy guide to 4 different types of attic extension which could add space and value to your property…",
    img: "./images/item4.jpg",
    button: "Read More",
  },
  {
    id: 5,
    title: "House Renovations",
    category: "House Renovations",
    desc: "Thinking of moving but horrified by the cost? Ever considered a house renovation to create the home you need instead? With the average London terrace coming in at just under £700,000, you’re looking at a whopping £25,000 on stamp duty alone. If your home’s worth around £1.5 million you’re looking at paying stamp duty of over £90,000. That’s even before all the other expenses of moving…",
    img: "./images/item5.jpg",
    button: "Read More",
  },
  {
    id: 6,
    title: "Commercial",
    category: "Commercial",
    desc: "As an experienced commercial building contractor in London, over the last decade and a half, we’ve helped businesses big and small transform their workspace into a stimulating  environment for happier, more productive people. Whether you’re retail giant or a start-up, we’re a great fit.",
    img: "./images/item6.jpg",
    button: "Read More",
  },
];

export default servicesData;
